import ModalBaseBody from "./ModalBaseBody";
import ModalBaseHeader from "./ModalBaseHeader";
import ModalBaseRoot from "./ModalBaseRoot";
import ModalBaseFooter from "./ModalBaseFooter";

export const ModalBase = { Root: ModalBaseRoot, Header: ModalBaseHeader, Body: ModalBaseBody, Footer: ModalBaseFooter };
